
import { Component, Vue } from 'vue-property-decorator'
import { MediaService } from '@/services/index'
import { Form as ElForm } from 'element-ui'

@Component({
    name: 'MediaOrgEdit',
    components: {
    }
})
export default class extends Vue {

    private relationRules = {
        parentMedia: [
            { required: true, message: '请输入父媒体', trigger: 'blur' }
        ],
        childMedias: [
            { required: true, message: '请输入子媒体', trigger: 'blur' }
        ]
    }
    private parentMedia: any = {}
    private childMedias: any = []
    private relationForm = {
        parentMedia: {},
        childMedias: []
    }
    private relationId: number = 0
    private isUpdateLoading: boolean = false
    private isDeleteLoading: boolean = false
    private isSearching: boolean = false
    private parentMediaOptions: any = []
    private childMediaOptions: any = []

    private mounted() {
        this.relationId = parseInt(this.$route.params.id)
        this.getRelationDetail(this.relationId)
    }

    private async getRelationDetail(id: number) {
        const result = await MediaService.getRelation({ rel_id: id })
        if (result.status === 200) {
            this.parentMedia = result.data.parent_media
            this.childMedias = result.data.child_medias
            this.parentMediaOptions = [{ value: this.parentMedia.id, label: this.parentMedia.name }]
            this.childMediaOptions = this.childMedias.map((media: any) => {
                return { value: media.id, label: media.name }
            })
            this.relationForm = {
                parentMedia: { value: this.parentMedia.id, label: this.parentMedia.name },
                childMedias: this.childMedias.map((media: any) => { 
                    return { value: media.id, label: media.name } 
                })
            }
        }
    }

    private async getParentMedias(query: any) {
        if (query !== '') {
            this.isSearching = true
            const result = await MediaService.searchMedia({ value: query })
            if (result.status === 200) {
                this.parentMediaOptions = result.data.map((item: any) => {
                    return { value: item.id, label: item.name }
                })
            }
            this.isSearching = false
        } else {
            this.parentMediaOptions = []
        }
    }

    private async getChildMedias(query: any) {
        if (query !== '') {
            this.isSearching = true
            const result = await MediaService.searchMedia({ value: query })
            if (result.status === 200) {
                this.childMediaOptions = result.data.map((item: any) => {
                    return { value: item.id, label: item.name }
                })
            }
            this.isSearching = false
        } else {
            this.childMediaOptions = []
        }
    }

    private onSelectParentChange() {
        (this.$refs.relationForm as ElForm).validateField('parentMedia')
    }

    private onSelectChildChange() {
        (this.$refs.relationForm as ElForm).validateField('childMedias')
    }

    private onUpdate() {
        (this.$refs.relationForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.isUpdateLoading = true
                const { parentMedia, childMedias }: any = this.relationForm
                const params: any = { 
                    parent_media: { id: parentMedia.value, name: parentMedia.label }, 
                    child_medias: childMedias.map((media: any) => { 
                        return { id: media.value, name: media.label } 
                    })
                }
                const result = await MediaService.createRelation(params)
                if (result.status === 200) {
                    this.$message({ type: 'success', message: '编辑成功' })
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.isUpdateLoading = false
            } else {
                return false
            }
        })
    }

    private onRemove() {
        this.$confirm('确认删除此关系?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.isDeleteLoading = true
            const result = await MediaService.deleteRelation({ id: this.relationId })
            if (result.status === 200) {
                this.$message({ type: 'success', message: '删除成功' })
            } else {
                this.$message({ type: 'error', message: result.message })
            }
            this.isDeleteLoading = false
        }).catch(() => {
            this.$message({ type: 'info', message: '已取消操作' })         
        })
    }
}
